$(function() {
    //  DEFAULT OPTION OPACITY
    $('.form-input--big').on('change', function () {
        if($(this).val()){

        } else {
            $(this).addClass('tx-black weight-500');
        }
    });

    // ANIMATE HEADER
    var lastScrollY = 0;

    if ($('#btn_apply_filters').length == 1) {
        window.addEventListener('scroll', function () {
            var currentScrollY = window.scrollY;
            if (currentScrollY > 35) {
                if (currentScrollY > lastScrollY) {
                    $('.main__header').addClass('main__header--scroll-down');
                    $('.main__header').removeClass('main__header--scroll-up');

                    $('.main__filters').removeClass('pt-24 sm:pt-13 md:pt-21').addClass('pt-3');

                    $('#btn_apply_filters, #btn_apply_filters_agency').removeClass('mt-16');
                }else{
                    $('.main__header').removeClass('main__header--scroll-down');
                    $('.main__header').addClass('main__header--scroll-up');

                    $('.main__filters').addClass('pt-24 sm:pt-13 md:pt-21').removeClass('pt-3');
                    $('#btn_apply_filters, #btn_apply_filters_agency').addClass('mt-16');
                }
                lastScrollY = currentScrollY;
            } else {
                $('.main__header').removeClass('main__header--scroll-up');
            }
        });
    }

    var lastScrollYHome = 0;
    window.addEventListener('scroll', function () {
        var currentScrollY = window.scrollY;

        if (currentScrollY == 0){
            $('.content__home').removeClass('content__home--scrolled content__home--scrolled-h');
        }

        if (currentScrollY > 120) {
            $('.content__home').addClass('content__home--scrolled');
        }

        if (currentScrollY > 400) {
            $('.content__home').addClass('content__home--scrolled-h');
        }
    });

    //  SHOW PASSWORD
    $('.form-helper--auth').on('click', function () {
        var src = $(this).find('img').attr('src');
        var newsrc = (src == '/assets/images/helpers/eye-regular.svg') ? '/assets/images/helpers/eye-slash-regular.svg' : '/assets/images/helpers/eye-regular.svg';
        $(this).find('img').attr('src', newsrc );

        var type = $(this).next('input[type="password"]').prop('type');
        var newtype = (type == 'password') ? 'text' : 'password';
        $(this).next('input').prop('type', newtype);
    });

    //  ACTIONS BACKDROP
    $('.backdrop').on('click', function () {
        $('#main_filters').removeClass('toggled');
        $('body').removeClass('overflow-hidden');
        $(this).fadeOut(100);
        $('#trigger_filters_catalog .icon-times').toggleClass('hidden');
        $('#trigger_filters_catalog .icon-filter').toggleClass('hidden');
    });

    //  TRIGGER MAIN FILTERS
    $('#trigger_filters_catalog').on('click', function () {
        $('body').toggleClass('overflow-hidden');
        $('#main_filters').toggleClass('toggled');
        $('.backdrop').fadeToggle(200);
        $(this).find('.icon-times').toggleClass('hidden');
        $(this).find('.icon-filter').toggleClass('hidden');
    });

    if ($('#btn_apply_filters').length == 1) {
        window.addEventListener('scroll', function () {
            const btn_apply_filters = document.getElementById('btn_apply_filters');
            const btn_apply_filters_static = document.getElementById('btn_apply_filters_static');
            var currentScrollY = window.scrollY;

            if (currentScrollY >= 200) {
                btn_apply_filters.classList.add('btn--fixed');
                btn_apply_filters_static.classList.add('opacity-0');
            }

            if (currentScrollY <= 132) {
                btn_apply_filters.classList.remove('btn--fixed');
                btn_apply_filters_static.classList.remove('opacity-0');
            }
        });
    }

    if ($('#btn_apply_filters_agency').length == 1) {
        window.addEventListener('scroll', function () {
            const btn_apply_filters_agency = document.getElementById('btn_apply_filters_agency');
            const btn_apply_filters_static = document.getElementById('btn_apply_filters_static');
            var currentScrollY = window.scrollY;

            if (currentScrollY > 500) {
                btn_apply_filters_agency.classList.add('btn--fixed');
                btn_apply_filters_static.classList.add('opacity-0');
            }

            if (currentScrollY < 430) {
                btn_apply_filters_agency.classList.remove('btn--fixed');
                btn_apply_filters_static.classList.remove('opacity-0');
            }

        });
    }

    //  OVERLAY PREVENT
    $('.overlay--help, .close-modal--help').click(function(){
        if( $(this).find('.vs__dropdown-menu').length == 0 ) {
            $('.overlay--help').fadeOut(100);
            $('body').removeClass('overflow-hidden');
        }
    });
    $('.lightbox--help').click(function(e){
        e.stopPropagation();
    });

    // TRIGGER MODAL HELP
    setTimeout(() => {
        $('#modal_help').fadeIn();
    }, 15000);

    setTimeout(() => {
        $('.alert-mail').fadeOut();
    }, 6000);

    $('#close_cookie').click(function() {
        $('.cookie-notification').fadeOut(100);
        document.cookie = "accept-cookie='true'; expires= 01 Jan 3000 00:00:00 UTC";
    });

    //  LOADER
    $('.loader').fadeOut(300);
});
